import moment from "moment"
import { Alert } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import { useStore } from "@/zustand/store"

import styles from "./BirthdayBanner.module.css"

export default function BirthdayBanner() {
  const { t } = useTranslation()
  const authData = useStore((state) => state.authData)

  const isBirthday = () => {
    if (!authData?.user?.birthdate) {
      return false
    }

    const today = moment()
    const birthdate = moment(authData.user.birthdate)

    return (
      today.month() === birthdate.month() && today.date() === birthdate.date()
    )
  }

  if (!authData || !isBirthday()) {
    return null
  }

  const userName = authData?.user?.name || "Student"

  return (
    <Alert
      variant="success"
      dismissible={false}
      show={true}
      className={styles.banner}
    >
      <div className={styles.content}>
        <div className={styles.textContent}>
          <p className={styles.title}>
            {`🎉 ${t("birthdayBanner.title")} ${userName}! 🎉`}
          </p>
          <p className={styles.description}>{t("birthdayBanner.message")}</p>
        </div>
      </div>
    </Alert>
  )
}
